<style scoped lang="scss">
    .file-dropzone {
        border: none;
        text-align: center;
    }
    .vue-dropzone {
        background: #eee;
        border: thin dashed #666;
        padding: 0;
        margin: 0;
        min-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        .dropzone-custom-title {
            margin: 0;
        }
    }
    .file-wrapper {
        display: flex;
        align-items: center;
    }
    .file-name {
        display: block;
        min-width: 300px;
    }
</style>

<template>
    <div class="uk-grid">
        <div class="uk-width-1-1">
            <h3 v-if="title">{{ title }}</h3>
            <p v-if="subTitle" v-html="subTitle"></p>
            <div>
                <vue-dropzone
                    :ref="refName"
                    :options="dropzoneOptions"
                    :useCustomSlot=true
                    v-on:vdropzone-sending="sendingFile"
                    v-on:vdropzone-max-files-exceeded="onMaxFilesExceeded"
                    v-on:vdropzone-success="onFileUpdated"
                >
                  <div class="dropzone-custom-content file-dropzone">
                    <p class="dropzone-custom-title">Drop File Here or Click to Select a File!</p>
                  </div>
                </vue-dropzone>
            </div>
        </div>

        <div class="uk-width-1-1 uk-margin-large-top" v-if="documents.length">
            <div v-for="(document, index) in documents" class="uk-margin-bottom file-wrapper">
                <div class="icon-container">
                    <a href="javascript:;" @click="previewFile(document)" class="custom-link">
                        <i class="uk-icon-medium a-file-search"></i><br>
                        <span style="font-size: 0.8em;">PREVIEW</span>
                    </a>
                </div>
                <a :href="`documents/download/${document.id}`" target="_blank" class="file-name custom-link"><span class="uk-margin-left">{{document.filename}}</span></a>
                <a href="javascript:;" class="uk-button uk-button-danger uk-margin-left" @click="deleteDocument(index, document)"><i class="fa fa-trash"></i></a>
            </div>
        </div>
        <preview-document-modal ref="previewModal"></preview-document-modal>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import ValidatedSection from "../hope/components/Common/ValidatedSection";
    import PreviewDocumentModal from "../dashboard/pages/Documents/PreviewDocumentModal";

    export default {
        name: "FileUploadDropdzone",
        props: {
            uploadUrl: {
                type: String,
                required: true,
            },
            accepts: {
                type: String,
                default: '',
            },
            fileType: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            subTitle: {
                type: String,
                default: ''
            },
            member: {
                type: Object,
                default: {}
            },
            refName: {
                type: String,
                default: 'dropzoneUpload'
            },
            documents: {
                type: Array,
                default: []
            }
        },
        components: {
            vueDropzone: vue2Dropzone,
            ValidatedSection,
            PreviewDocumentModal,
        },
        computed: {
            ...mapState('Application', {
                application: 'application',
            }),
        },
        data() {
            return {
                errors: {},
                dropzoneOptions: {
                    url: this.uploadUrl,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    maxFiles: 1,
                    acceptedFiles: this.accepts,
                },
            }
        },
        methods: {
            previewFile(document) {
                let url =`/api/hope/documents/${document.id}/preview`;
                this.$refs.previewModal.open(url, document);
            },

            sendingFile(file, xhr, formData) {
                formData.append('application_id', this.application.id);
                formData.append('household_member_id', this.member.id);
                formData.append('type', this.fileType);
            },

            onMaxFilesExceeded(file) {
                this.$refs[this.refName].removeAllFiles();
                this.$refs[this.refName].manuallyAddFile(file);
            },

            _getDocumentIdsFromOrgFiles(files) {
                if (files && files.length)
                {
                    const res = JSON.parse(files[0].xhr.response);
                    return [res.document]
                }
                return []
            },

            getDocuments() {
                const orgFiles = this.$refs[this.refName].getAcceptedFiles()
                return this._getDocumentIdsFromOrgFiles(orgFiles);
            },

            onFileUpdated() {
                const newDocs = this.getDocuments();
                if (newDocs && newDocs.length)
                    this.$emit('fileAdded', {
                        type: this.fileType,
                        files: newDocs,
                    });

                this.$refs[this.refName].removeAllFiles();
            },

            deleteDocument(index, doc) {
                this.$store
                    .dispatch('Document/deleteDocument', doc.id)
                    .then((res) => {
                        this.$emit('fileDeleted', {
                            type: this.fileType,
                            index: index
                        });
                    })
                    .catch((err) => {
                    })
            },
        },
    }
</script>
